import { ɵɵdefineInjectable, ɵsetClassMetadata, Injectable, ɵɵinject, PLATFORM_ID, Optional, Inject, ɵɵdirectiveInject, TemplateRef, ViewContainerRef, ɵɵdefineDirective, Directive, ɵɵdefineNgModule, ɵɵdefineInjector, ɵɵsetNgModuleScope, NgModule, InjectionToken, ApplicationRef } from '@angular/core';
import { makeStateKey, TransferState, Meta, Title, BrowserTransferStateModule } from '@angular/platform-browser';
import { isPlatformBrowser, isPlatformServer, DOCUMENT } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';
import { filter, take, tap } from 'rxjs/operators';
import { HttpResponse, HttpHeaders, HTTP_INTERCEPTORS } from '@angular/common/http';
import { of } from 'rxjs';

class WindowService {
    constructor() {
        // Some typical window use-cases
        this.navigator = {};
        this.location = {};
        this.document = {};
        // Google tag manager stub for web
        this.dataLayer = [];
    }
    addEventListener() { }
    alert(msg) { return; }
    confirm(msg) { return; }
    btoa(msg) { return null; }
    scrollTo(a, b) { return null; }
    open(...args) { return null; }
    setTimeout(handler, timeout) { return 0; }
    clearTimeout(timeoutId) { }
    setInterval(handler, ms, ...args) { return 0; }
    clearInterval(intervalId) { }
    resizeHeroText(textEl) { }
    ;
    // Google analytics stub for web
    ga(command, params, extra) { }
}
/** @nocollapse */ WindowService.ɵfac = function WindowService_Factory(t) { return new (t || WindowService)(); };
/** @nocollapse */ WindowService.ɵprov = ɵɵdefineInjectable({ token: WindowService, factory: WindowService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(WindowService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], null, null); })();

class NgUniversalConfig {
    constructor() {
        this.renderTimeout = 5000;
    }
}

// @dynamic
class PlatformService {
    constructor(optionalConfig, platformId, doc, windowService, transferState) {
        this.platformId = platformId;
        this.doc = doc;
        this.windowService = windowService;
        this.transferState = transferState;
        this.config = optionalConfig;
        if (this.isBrowser) {
            this.windowService.firstSSRRender = true;
            setTimeout(() => {
                this.windowService.firstSSRRender = false;
            }, 4000);
        }
    }
    get document() {
        return this.doc;
    }
    get connection() {
        // tslint:disable-next-line: no-string-literal
        if (typeof navigator !== undefined && navigator['connection']) {
            return null;
        }
        // tslint:disable-next-line: no-string-literal
        return navigator['connection'];
    }
    get isBrowser() {
        return isPlatformBrowser(this.platformId);
    }
    get isServer() {
        return isPlatformServer(this.platformId);
    }
    // Automatically remove from Cache
    doNotCache(url, requestMethod = 'GET') {
        if (this.isBrowser) {
            this.transferState.remove(makeStateKey((requestMethod === 'GET' ? 'G.' : 'P.') + url));
        }
    }
    get isFirstRenderAfterSSR() {
        return this.isBrowser && this.windowService.firstSSRRender;
    }
    get isFirstNavigationAfterSSR() {
        return this.isBrowser && this.windowService.firstSSRNavigation;
    }
    // Safe way to scroll that shuts off html's 100% height (which disables our ability to scroll)
    scrollTo(x, y) {
        if (this.isBrowser) {
            this.document.querySelector('html').style.height = 'auto';
            this.windowService.scrollTo(0, 0);
            this.windowService.setTimeout(() => {
                this.document.querySelector('html').style.height = '100%';
            }, 250);
        }
    }
}
/** @nocollapse */ PlatformService.ɵfac = function PlatformService_Factory(t) { return new (t || PlatformService)(ɵɵinject(NgUniversalConfig, 8), ɵɵinject(PLATFORM_ID), ɵɵinject(DOCUMENT), ɵɵinject(WindowService), ɵɵinject(TransferState)); };
/** @nocollapse */ PlatformService.ɵprov = ɵɵdefineInjectable({ token: PlatformService, factory: PlatformService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(PlatformService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: NgUniversalConfig, decorators: [{
                type: Optional
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }, { type: Document, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: WindowService }, { type: TransferState }]; }, null); })();

class IsBrowserDirective {
    constructor(templateRef, viewContainer, platformService) {
        this.templateRef = templateRef;
        this.viewContainer = viewContainer;
        this.platformService = platformService;
    }
    ngOnInit() {
        if (this.platformService.isBrowser) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        }
        else {
            this.viewContainer.clear();
        }
    }
}
/** @nocollapse */ IsBrowserDirective.ɵfac = function IsBrowserDirective_Factory(t) { return new (t || IsBrowserDirective)(ɵɵdirectiveInject(TemplateRef), ɵɵdirectiveInject(ViewContainerRef), ɵɵdirectiveInject(PlatformService)); };
/** @nocollapse */ IsBrowserDirective.ɵdir = ɵɵdefineDirective({ type: IsBrowserDirective, selectors: [["", "isBrowser", ""]] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(IsBrowserDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: '[isBrowser]'
            }]
    }], function () { return [{ type: TemplateRef }, { type: ViewContainerRef }, { type: PlatformService }]; }, null); })();

class IsServerDirective {
    constructor(templateRef, viewContainer, platformService) {
        this.templateRef = templateRef;
        this.viewContainer = viewContainer;
        this.platformService = platformService;
    }
    ngOnInit() {
        if (this.platformService.isServer) {
            this.viewContainer.createEmbeddedView(this.templateRef);
        }
        else {
            this.viewContainer.clear();
        }
    }
}
/** @nocollapse */ IsServerDirective.ɵfac = function IsServerDirective_Factory(t) { return new (t || IsServerDirective)(ɵɵdirectiveInject(TemplateRef), ɵɵdirectiveInject(ViewContainerRef), ɵɵdirectiveInject(PlatformService)); };
/** @nocollapse */ IsServerDirective.ɵdir = ɵɵdefineDirective({ type: IsServerDirective, selectors: [["", "isServer", ""]] });
/*@__PURE__*/ (function () { ɵsetClassMetadata(IsServerDirective, [{
        type: Directive,
        args: [{
                // tslint:disable-next-line:directive-selector
                selector: '[isServer]'
            }]
    }], function () { return [{ type: TemplateRef }, { type: ViewContainerRef }, { type: PlatformService }]; }, null); })();

class LinkService {
    constructor(document /* Document */, router) {
        this.document = document;
        this.router = router;
    }
    /**
     * Create or update a link tag
     * @param  LinkDefinition tag
     */
    updateTag(tag) {
        const selector = this._parseSelector(tag);
        const linkElement = this.document.head.querySelector(selector)
            || this.document.head.appendChild(this.document.createElement('link'));
        if (linkElement) {
            Object.keys(tag).forEach((prop) => {
                linkElement[prop] = tag[prop];
            });
        }
    }
    /**
     * Remove a link tag from DOM
     */
    removeTag(tag) {
        const selector = this._parseSelector(tag);
        const linkElement = this.document.head.querySelector(selector);
        if (linkElement) {
            this.document.head.removeChild(linkElement);
        }
    }
    /**
     * Get link tag
     * @return HTMLLinkElement
     */
    getTag(tag) {
        const selector = this._parseSelector(tag);
        return this.document.head.querySelector(selector);
    }
    /**
     * Get all link tags
     * @return NodeListOf<HTMLLinkElement>
     */
    getTags() {
        return this.document.head.querySelectorAll('link');
    }
    /**
     * Parse tag to create a selector
     * @return string} selector to use in querySelector
     */
    _parseSelector(tag) {
        const attr = tag.rel ? 'rel' : 'hreflang';
        return `link[${attr}="${tag[attr]}"]`;
    }
    /**
     * Start listening on NavigationEnd router events
     */
    startRouteListener() {
        this.routeListener = this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(() => {
            let url = '';
            const urlTree = this.router.parseUrl(this.router.url);
            if (urlTree.root.hasChildren()) {
                const segments = urlTree.root.children['primary'].segments;
                if (segments && segments.length > 0) {
                    url = segments.map(segment => segment.path).join('/');
                }
            }
            this.updateTag({
                rel: 'canonical',
                href: `/${url}`
            });
        });
    }
    /**
     * Destroy route listener when service is destroyed
     */
    ngOnDestroy() {
        if (this.routeListener) {
            this.routeListener.unsubscribe();
        }
    }
}
/** @nocollapse */ LinkService.ɵfac = function LinkService_Factory(t) { return new (t || LinkService)(ɵɵinject(DOCUMENT), ɵɵinject(Router)); };
/** @nocollapse */ LinkService.ɵprov = ɵɵdefineInjectable({ token: LinkService, factory: LinkService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(LinkService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: Router }]; }, null); })();

class SeoService {
    constructor(meta, title, document /* Document */, linkService) {
        this.meta = meta;
        this.title = title;
        this.document = document;
        this.linkService = linkService;
    }
    initializeBaseMeta(baseMeta) {
        return this.baseMeta = Object.assign({}, baseMeta);
    }
    update(seoConfig) {
        this.metaUpdate = Object.assign(Object.assign({}, this.baseMeta), seoConfig);
        const seo = {
            title: this.metaUpdate.title,
            meta: [
                // Essentials
                { property: 'keywords', content: this.metaUpdate.keywords },
                // Defaults
                { property: 'og:url', content: this.metaUpdate.url },
                { property: 'og:locale', content: this.metaUpdate.locale || 'en_US' },
                { property: 'og:type', content: this.metaUpdate.type || 'website' },
                { property: 'twitter:card', content: this.metaUpdate.twitter.summary_card || 'summary_large_image' },
                // Title
                { property: 'og:title', content: this.metaUpdate.title },
                { property: 'twitter:title', content: this.metaUpdate.title },
                { property: 'twitter:image:alt', content: this.metaUpdate.title },
                // Description
                { name: 'description', content: this.metaUpdate.description },
                { property: 'og:description', content: this.metaUpdate.description },
                { property: 'twitter:description', content: this.metaUpdate.description },
                ...(this.metaUpdate.og
                    ? [
                        ...(this.metaUpdate.og.site_name ? [{ property: 'og:site_name', content: this.metaUpdate.og.site_name }] : []),
                        ...(this.metaUpdate.og.image_url ? [{ property: 'og:image', content: this.metaUpdate.og.image_url }] : []),
                        { property: 'og:image:width', content: this.metaUpdate.og.image_width || '1200' },
                        { property: 'og:image:height', content: this.metaUpdate.og.image_height || '630' }
                    ]
                    : []),
                ...(this.metaUpdate.twitter
                    ? [
                        ...(this.metaUpdate.twitter.image_url ? [{ property: 'twitter:image', content: this.metaUpdate.twitter.image_url }] : []),
                        ...(this.metaUpdate.twitter.site ? [{ property: 'twitter:site', content: this.metaUpdate.twitter.site }] : []),
                        ...(this.metaUpdate.twitter.creator ? [{ property: 'twitter:creator', content: this.metaUpdate.twitter.creator }] : []),
                        ...(this.metaUpdate.twitter.image_alt ? [{ property: 'twitter:image:alt', content: this.metaUpdate.twitter.image_alt }] : []),
                    ]
                    : []),
                ...(this.metaUpdate.msapplicationTileColor
                    ? [{ property: 'msapplication-TileColor', content: this.metaUpdate.msapplicationTileColor }]
                    : []),
                ...(this.metaUpdate.themeColor
                    ? [{ property: 'theme-color', content: this.metaUpdate.themeColor }]
                    : []),
                // Blog-Related
                ...(this.metaUpdate.article && this.metaUpdate.article.tags
                    ? [...this.metaUpdate.article.tags.map(tag => ({ name: 'article:tag', content: `${tag}` }))]
                    : []),
                ...(this.metaUpdate.article && this.metaUpdate.article.section
                    ? [{ property: 'article:section', content: this.metaUpdate.article.section }]
                    : []),
            ],
            link: (this.metaUpdate.link ? this.metaUpdate.link : null)
        };
        this.updateMeta(seo);
    }
    updateMeta(seoModel) {
        Object.keys(seoModel).forEach(key => {
            const metaVal = seoModel[key];
            switch (key) {
                case 'title':
                    this.title.setTitle(metaVal);
                    return;
                case 'meta':
                    metaVal.map((meta) => {
                        this.meta.updateTag(meta);
                        return meta;
                    });
                    return;
                case 'link':
                    metaVal.map((link) => {
                        this.linkService.updateTag(link);
                        return link;
                    });
                    return;
                default:
                    return;
            }
        });
    }
    updateStructuredData(data) {
        const exists = this.document.querySelector('#ld-json-script');
        if (exists) {
            exists.remove();
        }
        const json = data
            ? JSON.stringify(data).replace(/<\/script>/g, '<\\/script>')
            : '';
        const scriptElem = this.document.createElement('script');
        scriptElem.type = 'application/ld+json';
        scriptElem.id = 'ld-json-script';
        scriptElem.innerHTML = json;
        this.document.head.appendChild(scriptElem);
    }
}
/** @nocollapse */ SeoService.ɵfac = function SeoService_Factory(t) { return new (t || SeoService)(ɵɵinject(Meta), ɵɵinject(Title), ɵɵinject(DOCUMENT), ɵɵinject(LinkService)); };
/** @nocollapse */ SeoService.ɵprov = ɵɵdefineInjectable({ token: SeoService, factory: SeoService.ɵfac, providedIn: 'root' });
/*@__PURE__*/ (function () { ɵsetClassMetadata(SeoService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: Meta }, { type: Title }, { type: undefined, decorators: [{
                type: Inject,
                args: [DOCUMENT]
            }] }, { type: LinkService }]; }, null); })();

class NgUniversalModule {
}
/** @nocollapse */ NgUniversalModule.ɵmod = ɵɵdefineNgModule({ type: NgUniversalModule });
/** @nocollapse */ NgUniversalModule.ɵinj = ɵɵdefineInjector({ factory: function NgUniversalModule_Factory(t) { return new (t || NgUniversalModule)(); }, providers: [
        PlatformService,
        SeoService,
        WindowService,
        LinkService
    ], imports: [[
            BrowserTransferStateModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(NgUniversalModule, { declarations: [IsBrowserDirective,
        IsServerDirective], imports: [BrowserTransferStateModule], exports: [IsBrowserDirective,
        IsServerDirective] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(NgUniversalModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    IsBrowserDirective,
                    IsServerDirective,
                ],
                imports: [
                    BrowserTransferStateModule
                ],
                exports: [
                    IsBrowserDirective,
                    IsServerDirective,
                ],
                providers: [
                    PlatformService,
                    SeoService,
                    WindowService,
                    LinkService
                ]
            }]
    }], null, null); })();

const TRANSFER_STATE_CACHE_OPTIONS = new InjectionToken('TRANSFER_STATE_CACHE_OPTIONS');

function getHeadersMap(headers) {
    const headersMap = {};
    for (const key of headers.keys()) {
        headersMap[key] = headers.getAll(key);
    }
    return headersMap;
}
class TransferHttpCacheInterceptor {
    constructor(appRef, transferState, options) {
        this.transferState = transferState;
        this.options = options;
        this.isCacheActive = true;
        // Stop using the cache if the application has stabilized, indicating initial rendering is
        // complete.
        appRef.isStable
            .pipe(filter((isStable) => isStable), take(1)).toPromise()
            .then(() => {
            this.isCacheActive = false;
        });
    }
    // private hashSeparator = '::';
    invalidateCacheEntry(url) {
        Object.keys(this.transferState['store'])
            .forEach(key => key.includes(url) ? this.transferState.remove(makeStateKey(key)) : null);
    }
    makeCacheKey(method, url, params) {
        // make the params encoded same as a url so it's easy to identify
        const encodedParams = params.keys().sort().map(k => `${k}=${params.get(k)}`).join('&');
        const key = method[0] + url + '?' + encodedParams;
        return makeStateKey(key);
    }
    intercept(req, next) {
        const storeKey = this.makeCacheKey(req.method, req.url, req.params);
        // Stop using the cache if there is a mutating call.
        if (!this.isAllowedRequestMethod(req)) {
            this.isCacheActive = false;
            this.invalidateCacheEntry(storeKey);
        }
        if (!this.isCacheActive && !this.transferState.hasKey(storeKey) || !this.isPostRequestAllowed(req, storeKey)) {
            // Cache is no longer active. Pass the request through.
            return next.handle(req);
        }
        if (this.transferState.hasKey(storeKey)) {
            // Request found in cache. Respond using it.
            const response = this.transferState.get(storeKey, {});
            this.invalidateCacheEntry(storeKey);
            return of(new HttpResponse({
                body: response.body,
                headers: new HttpHeaders(response.headers),
                status: response.status,
                statusText: response.statusText,
                url: response.url,
            }));
        }
        else {
            // Request not found in cache. Make the request and cache it.
            const httpEvent = next.handle(req);
            return httpEvent
                .pipe(tap((event) => {
                if (event instanceof HttpResponse) {
                    this.transferState.set(storeKey, {
                        body: event.body,
                        headers: getHeadersMap(event.headers),
                        status: event.status,
                        statusText: event.statusText,
                        // tslint:disable-next-line:no-non-null-assertion
                        url: event.url,
                    });
                }
            }));
        }
    }
    isAllowedRequestMethod(req) {
        return req.method === 'GET' || req.method === 'HEAD' || req.method === 'POST';
    }
    isPostRequestAllowed(req, storeKey) {
        if (req.method !== 'POST') {
            return true;
        }
        return req.method === 'POST' && this.options.cachePOSTFilter && this.options.cachePOSTFilter(req, storeKey);
    }
}
/** @nocollapse */ TransferHttpCacheInterceptor.ɵfac = function TransferHttpCacheInterceptor_Factory(t) { return new (t || TransferHttpCacheInterceptor)(ɵɵinject(ApplicationRef), ɵɵinject(TransferState), ɵɵinject(TRANSFER_STATE_CACHE_OPTIONS)); };
/** @nocollapse */ TransferHttpCacheInterceptor.ɵprov = ɵɵdefineInjectable({ token: TransferHttpCacheInterceptor, factory: TransferHttpCacheInterceptor.ɵfac });
/*@__PURE__*/ (function () { ɵsetClassMetadata(TransferHttpCacheInterceptor, [{
        type: Injectable
    }], function () { return [{ type: ApplicationRef }, { type: TransferState }, { type: undefined, decorators: [{
                type: Inject,
                args: [TRANSFER_STATE_CACHE_OPTIONS]
            }] }]; }, null); })();

/**
* An NgModule used in conjunction with `ServerTransferHttpCacheModule` to transfer cached HTTP
* calls from the server to the client application.
* Useage:
*
export function cacheFilter(req, key) {
  // determine what req.url's can pass through (or let all POST requests go through)
  return true;
}

imports: [
  ServerTransferHttpCacheModule, // from platform-server
  TransferHttpCacheModule.forRoot({
    cachePOSTFilter: cacheFilter
  })
]
*/
class TransferHttpCacheModule {
    static forRoot(options) {
        return {
            ngModule: TransferHttpCacheModule,
            providers: [
                TransferHttpCacheInterceptor,
                { provide: TRANSFER_STATE_CACHE_OPTIONS, useValue: options ? options : {} },
                { provide: HTTP_INTERCEPTORS, useExisting: TransferHttpCacheInterceptor, multi: true },
            ],
        };
    }
}
/** @nocollapse */ TransferHttpCacheModule.ɵmod = ɵɵdefineNgModule({ type: TransferHttpCacheModule });
/** @nocollapse */ TransferHttpCacheModule.ɵinj = ɵɵdefineInjector({ factory: function TransferHttpCacheModule_Factory(t) { return new (t || TransferHttpCacheModule)(); }, imports: [[BrowserTransferStateModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵɵsetNgModuleScope(TransferHttpCacheModule, { imports: [BrowserTransferStateModule] }); })();
/*@__PURE__*/ (function () { ɵsetClassMetadata(TransferHttpCacheModule, [{
        type: NgModule,
        args: [{
                imports: [BrowserTransferStateModule]
            }]
    }], null, null); })();

function prebootstrap() {
    if (typeof window === 'undefined') {
        return false;
    }
    const windowInstance = window;
    windowInstance.bootstraping = true;
    windowInstance.firstSSRRender = true;
}
/**
 * function used inside
 * @param timeout time before firstSSRRender flips to false (default 5000ms)
 */
function afterbootstrap(timeout) {
    if (typeof window === 'undefined') {
        return false;
    }
    const windowInstance = window;
    windowInstance.bootstraping = false;
    windowInstance.setTimeout(() => {
        windowInstance.firstSSRRender = false;
    }, timeout);
}

/*
 * Public API Surface of ng-universal
 */

/**
 * Generated bundle index. Do not edit.
 */

export { IsBrowserDirective, IsServerDirective, LinkService, NgUniversalModule, PlatformService, SeoService, TransferHttpCacheModule, WindowService, afterbootstrap, prebootstrap };
//# sourceMappingURL=trilon-ng-universal.js.map
